<template>
  <div class="trainer-group">
    <div class="group-title">{{ title }}</div>
    <weui-group :notitle="true">
      <slot />
    </weui-group>
  </div>
</template>

<script>
import { WeuiGroup } from '@/components/weui';

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    components: {
        WeuiGroup,
    },
};
</script>

<style lang="scss" scoped>
.trainer-group + .trainer-group {
  margin-top: 5.333333333vw;
}

.group-title {
    margin-left: 5.333333333vw;
    font-size: 11.733333333vw;
    line-height: 1;
    color: #969696;
}
</style>



// WEBPACK FOOTER //
// src/components/trainer/TrainerGroup.vue